export default defineNuxtPlugin(() => {
  const route = useRoute();
  
  watch(() => route.fullPath, (path) => {
    useHead({
      link: [
        { rel: 'canonical', href: `https://sysreptor.com${path}` }
      ]
    });
  }, { immediate: true });
});
